/**
 * Formats a prompt version timestamp (YYMMDDHHmmss) into a readable date format
 * @param version The prompt version timestamp string
 * @returns Formatted date string or the original string if format is invalid
 */
export function formatPromptVersion(version: string): string {
  // Check if the version matches the expected format (YYMMDDHHmmss)
  if (/^\d{12}$/.test(version)) {
    try {
      const year = parseInt(version.substring(0, 2)) + 2000;
      const month = parseInt(version.substring(2, 4)) - 1; // JS months are 0-indexed
      const day = parseInt(version.substring(4, 6));
      const hour = parseInt(version.substring(6, 8));
      const minute = parseInt(version.substring(8, 10));
      const second = parseInt(version.substring(10, 12));

      const date = new Date(year, month, day, hour, minute, second);

      // Format: "May 11, 2025, 17:27:44"
      return `${date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      })}, ${date.toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      })}`;
    } catch {
      // If parsing fails, return the original string
      return version;
    }
  }

  // If the format doesn't match, return the original string
  return version;
}
